import React, { HTMLAttributes } from "react";
import cx from "clsx";
import { displayFontClassName } from "@/lib/fonts";
import { CommonComponentProps } from "./componentTypes";
import { cleanHtmlRestProps } from "@/lib/utils";

interface H1Props
  extends HTMLAttributes<HTMLHeadingElement>,
    CommonComponentProps {
  type?: "common" | "promo" | "small";
}

export function H1({ children, className, type = "common", ...rest }: H1Props) {
  return (
    <h1
      className={cx({
        [displayFontClassName]: type !== "promo",
        "hero-title": type === "common",
        "text-[32px] font-bold leading-[1.2] md:text-[32px]": type === "small",
        "relative z-20 bg-gradient-to-b from-primary to-amber-400 bg-clip-text font-display text-6xl font-bold text-transparent md:text-7xl lg:text-8xl":
          type === "promo",
        className,
      })}
      {...cleanHtmlRestProps(rest)}
    >
      {children}
    </h1>
  );
}
